<div class="d-flex justify-content-center search-box" style="z-index: 1;" id="search-box"
[ngStyle]="{'background-image': 'url(&quot;' + routeUploadFile+sectionSearchBox?.background_image + '&quot;)'}"
  >
    <div class="mt-4 col-xg-10 col-lg-10 col-md-10 col-xs-12" id="menu-principal" [ngStyle]="{'background-color': sectionSearchBox.background_box}">
        <div class="tabss flex-row col-xg-12 col-lg-12 col-md-12 col-xs-12 justify-content-center">
            <tabset id="search" style="width: 100%;">

                <!-- HOTELS -->
                <tab id="HOTELS" [active]="tab==='HOTELS'">
                    <ng-template tabHeading>
                        <a class="hotel" (click)="selectTab('HOTELS')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/ima_hotel.svg"
                                     [ngClass]="{'active': activeBtn === 'HOTELS'}"
                                     [style.filter]="getAlertFilter('HOTELS')"
                                     style="width: 28px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">ALOJAMIENTO</h5></span>
                        </a>
                    </ng-template>
                </tab>

                 <!-- EXPERIENCIAS (disabled placeholder) -->
                <tab id="FLIGHTS" [active]="tab==='FLIGHTS'" [disabled]="true">
                    <ng-template tabHeading>
                        <a class="tour  disabled-tab" (click)="selectTab('FLIGHTS')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/AEREO.svg"
                                     [ngClass]="{'active': activeBtn === 'FLIGHTS'}"
                                     [style.filter]="getAlertFilter('FLIGHTS')"
                                     style="width: 28px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">VUELOS</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <!-- EXPERIENCIAS -->
                <tab id="EXPERIENCIAS" [active]="tab==='EXPERIENCIAS'">
                    <ng-template tabHeading>
                        <a class="tour" (click)="selectTab('EXPERIENCIAS')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/road-map.svg"
                                     [ngClass]="{'active': activeBtn === 'EXPERIENCIAS'}"
                                     [style.filter]="getAlertFilter('EXPERIENCIAS')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">EXPERIENCIAS</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <!-- TRANSPORTE -->
                <tab id="TRANSPORTE" [active]="tab==='TRANSPORTE'">
                    <ng-template tabHeading>
                        <a class="bus" (click)="selectTab('TRANSPORTE')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/bus.svg"
                                     [ngClass]="{'active': activeBtn === 'TRANSPORTE'}"
                                     [style.filter]="getAlertFilter('TRANSPORTE')"
                                     style="width: 28px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">TRASLADO</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <tab id="MULTIDESTINO" [active]="tab==='MULTIDESTINO'" [disabled]="true">
                    <ng-template tabHeading>
                        <a class="pthemes disabled-tab" (click)="selectTab('MULTIDESTINO')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/multidestino.svg"
                                     [ngClass]="{'active': activeBtn === 'MULTIDESTINO'}"
                                     [style.filter]="getAlertFilter('MULTIDESTINO')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">MULTIDESTINO</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <!-- TICKETS -->
                <tab id="TICKETS" [active]="tab==='TICKETS'">
                    <ng-template tabHeading>
                        <a class="pthemes" (click)="selectTab('TICKETS')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/combi-ticket.svg"
                                     [ngClass]="{'active': activeBtn === 'TICKETS'}"
                                     [style.filter]="getAlertFilter('TICKETS')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">TICKETS</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <!-- CAR -->
                <tab id="CAR" [active]="tab==='CAR'">
                    <ng-template tabHeading>
                        <a class="cars" (click)="selectTab('CAR')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/car-compact.svg"
                                     [ngClass]="{'active': activeBtn === 'CAR'}"
                                     [style.filter]="getAlertFilter('CAR')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">RENT A CAR</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <tab id="PACKAGES" [active]="tab==='PACKAGES'" [disabled]="true">
                    <ng-template tabHeading>
                        <a class="cars disabled-tab" (click)="selectTab('PACKAGES')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/maleta.svg"
                                     [ngClass]="{'active': activeBtn === 'PACKAGES'}"
                                     [style.filter]="getAlertFilter('PACKAGES')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">PAQUETES</h5></span>
                        </a>
                    </ng-template>
                </tab>

                <!-- INSURANCE -->
                <tab id="INSURANCE" [active]="tab==='INSURANCE'">
                    <ng-template tabHeading>
                        <a class="seguro" (click)="selectTab('INSURANCE')">
                            <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
                                <img src="../../../assets/img/app/categories-search-box/icon-seguro.svg"
                                     [ngClass]="{'active': activeBtn === 'INSURANCE'}"
                                     [style.filter]="getAlertFilter('INSURANCE')"
                                     style="width: 30px;">
                            </span>
                            <span><h5 class="title-categories text-uppercase" [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">ASISTENCIA</h5></span>
                        </a>
                    </ng-template>
                </tab>

            </tabset>

            <!--
                Single body host for the active category. Lives OUTSIDE the
                ngx-bootstrap tabset on purpose: putting the child inside <tab>
                fights ngx-bootstrap's internal _active tracking and produces a
                visible flicker when switching tabs. Rendering exactly one
                <usb-X> via [ngSwitch] keeps our component lifecycle fully in
                our hands and the tabset only owns the heading row.
            -->
            <ng-container [ngSwitch]="tab">
                <usb-hotels *ngSwitchCase="'HOTELS'"
                            [_close]="_close"
                            [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                            (modal)="openModal($event)"
                            (payload)="_onPayload($event)"
                            (results)="_onResults($event)"
                            (isLoading)="_onLoading($event)"
                            (origin)="_onOrigin($event)">
                </usb-hotels>

                <usb-rentcars *ngSwitchCase="'CAR'"
                              [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                              (payload)="_onPayload($event)"
                              (results)="_onResults($event)"
                              (isLoading)="_onLoading($event)"
                              (origin)="_onOrigin($event)">
                </usb-rentcars>

                <usb-flights *ngSwitchCase="'FLIGHTS'"
                                [_close]="_close"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                (modal)="openModal($event)"
                                (origin)="_onOrigin($event)"
                                (payload)="_onPayload($event)"
                                (results)="_onResults($event)"
                                (isLoading)="_onLoading($event)">
                </usb-flights>

                <usb-activities *ngSwitchCase="'EXPERIENCIAS'"
                                [categoryId]="category.experience"
                                [_close]="_close"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                [tabName]="tab"
                                (modal)="openModal($event)"
                                (payload)="_onPayload($event)"
                                (results)="_onResults($event)"
                                (isLoading)="_onLoading($event)"
                                (origin)="_onOrigin($event)">
                </usb-activities>

                <usb-transports *ngSwitchCase="'TRANSPORTE'"
                                [_close]="_close"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                (modal)="openModal($event)"
                                (origin)="_onOrigin($event)"
                                (payload)="_onPayload($event)"
                                (results)="_onResults($event)"
                                (isLoading)="_onLoading($event)">
                </usb-transports>

                <usb-activities *ngSwitchCase="'TICKETS'"
                                [categoryId]="category.tickets"
                                [_close]="_close"
                                [getClientsSettingAppBooking]="getClientsSettingAppBooking"
                                [tabName]="tab"
                                (modal)="openModal($event)"
                                (payload)="_onPayload($event)"
                                (results)="_onResults($event)"
                                (isLoading)="_onLoading($event)"
                                (origin)="_onOrigin($event)">
                </usb-activities>

                <usb-insurance *ngSwitchCase="'INSURANCE'"
                               [_close]="_close"
                               (modal)="openModal($event)"
                               (payload)="_onPayload($event)"
                               (results)="_onResults($event)"
                               (isLoading)="_onLoading($event)"
                               (origin)="_onOrigin($event)">
                </usb-insurance>
            </ng-container>
        </div>
    </div>
</div>
